// import { thereIsAnUUIDV4InUrl } from "~/lib/shopify/utils/uuid-in-url"

export function imageSrcIsValid(src?: string) {
  // if src is not truthy, consider the image invalid
  if (!src) return null
  // // if there is an UUID in the url, consider the image invalid
  // if (thereIsAnUUIDV4InUrl(src)) return null

  // extract the filename from the url
  const filename = src?.split("/")?.reverse()?.[0]?.split(".")?.[0]
  // if the filename ends with -3, consider the image invalid
  if (filename?.endsWith("-3")) return null

  // otherwise, consider the image valid
  return src
}
